import {ADD_TRANSLATIONS} from "../../actions/TranslationActions";

const initialState = {
    translations: {}
};

const TranslationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TRANSLATIONS:
            return {...state, translations: {...state.translations, ...action.payload}};
        default:
            return state
    }
};

export default TranslationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/TranslationsReducer.js